import { render, staticRenderFns } from "./RegisterAvailabilityForm.vue?vue&type=template&id=6785a320&scoped=true&"
import script from "./RegisterAvailabilityForm.vue?vue&type=script&lang=ts&"
export * from "./RegisterAvailabilityForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterAvailabilityForm.vue?vue&type=style&index=0&id=6785a320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6785a320",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VForm,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6785a320')) {
      api.createRecord('6785a320', component.options)
    } else {
      api.reload('6785a320', component.options)
    }
    module.hot.accept("./RegisterAvailabilityForm.vue?vue&type=template&id=6785a320&scoped=true&", function () {
      api.rerender('6785a320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/management/components/RegisterAvailabilityForm.vue"
export default component.exports